






































































































































































import { recepturaResource } from "@megarax/client/src/resources/plm/Receptura";
import {
  Produkt,
  produktResource,
} from "@megarax/client/src/resources/plm/Produkt";
import { CreateElement, FunctionalComponentOptions } from "vue";
import {
  productGroupResource,
  obiektZastosowaniaResource,
  czescBudynkuResource,
  narzedzieResource,
  rozpuszczalnikResource,
  rodzajOpakowaniaResource,
  podlozeResource,
} from "@megarax/client/src/resources/plm";
import { createComponent, ref, computed } from "@vue/composition-api";
import DefaultRevisionForm from "@/components/DefaultRevisionForm.vue";
import { required, maxLength } from "@/shared/validationRules";
import { formValidator } from "@/shared/formValidator";

const validationRules = {
  name: required,
  nazwa: required,
  productGroup: required,
};

interface Props {
  value: Produkt;
}

export default createComponent<Props>({
  components: {
    DefaultRevisionForm,
  },
  props: {
    value: {
      required: true,
    },
  },
  setup({ value }) {
    return {
      ...formValidator(),
      czescBudynkuResource,
      productGroupResource,
      narzedzieResource,
      obiektZastosowaniaResource,
      podlozeResource,
      recepturaResource,
      resource: produktResource,
      rodzajOpakowaniaResource,
      rozpuszczalnikResource,
      validationRules,
    };
  },
});
